import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnpsComponent } from '@suite/common/components/base/enps-component';

@Component({
    template: ""
})
export class DraggableEnpsComponent extends EnpsComponent {
    @Input() public dragEnabled: boolean = true;
    @Input() public dragStarted: boolean = false;
    @Output() public onDragEnter: EventEmitter<string> = new EventEmitter<string>();

    public mouseEntered: boolean = false;

    protected _guid: string;
    @Input() public get guid(): string {
        return this._guid;
    }
    public set guid(guid: string) {
        this._guid = guid;
    }

    public onMouseEnter() {
        if (this.dragEnabled && this.dragStarted) {
            this.mouseEntered = true;
            this.onDragEnter.emit(this._guid);
        }
    }

    public onMouseLeave() {
        this.mouseEntered = false;
        if (this.dragEnabled && this.dragStarted) {
            this.onDragEnter.emit(null);
        }
    }
}